import React from 'react';
import { useEnabledFeatures } from '../common/hooks/enabled-features/use-enabled-features';
import { useOpenWorkspacePanel } from '../panels/use-open-workspace-panel';

export const COMPACT_CLI_HEIGHT = 113;
export const STANDARD_CLI_HEIGHT = 230;
export const THRESHOLD_CLI_HEIGHT = 150;

export function useOpenCommandLinePanel(): () => void {
    const { commandLineCompactByDefault } = useEnabledFeatures();
    const openWorkspacePanel = useOpenWorkspacePanel();

    const openCommandLinePanel = React.useCallback(() => {
        openWorkspacePanel({
            workspacePanelConfig: {
                width: 1024,
                height: commandLineCompactByDefault ? COMPACT_CLI_HEIGHT : STANDARD_CLI_HEIGHT,
                workspacePanelType: 'COMMAND_LINE',
            },

            matchExistingPanel: (panel) => {
                return panel.workspacePanelType === 'COMMAND_LINE';
            },
        });
    }, [commandLineCompactByDefault, openWorkspacePanel]);

    return openCommandLinePanel;
}
